import * as yup from 'yup';

/**
 * Esquema de validación dinámico para los features adicionales
 * @param {Array} features - Lista de características adicionales
 * @returns {Object} - Schema de validación de Yup
 */
export const validationsSchema = features => {
  if (!features || features.length === 0) {
    return yup.object().shape({});
  }

  const schemaFields = {};

  features.forEach(feature => {
    if (feature.fieldType === 'Num' || feature.fieldType === 'TextNum') {
      const minVal = feature.minValidation ? parseInt(feature.minValidation) : 0;
      const maxVal = feature.maxValidation ? parseInt(feature.maxValidation) : 9999999999;

      schemaFields[feature.id] = yup
        .string()
        .nullable()
        .transform(value => (value === '' ? null : value))
        .test('range-validation', `professionalPubli.extras.error.Num:${minVal}:${maxVal}`, value => {
          if (value === null || value === undefined) return true;
          const numValue = parseInt(value);
          return numValue >= minVal && numValue <= maxVal;
        });
    } else if (feature.fieldType === 'Text') {
      const maxLength = feature.maxValidation ? parseInt(feature.maxValidation) : null;

      schemaFields[feature.id] = yup
        .string()
        .nullable()
        .transform(value => (value === '' ? null : value))
        .test('max-length-validation', 'professionalPubli.extras.error.Text', value => {
          if (value === null || value === undefined) return true;
          if (maxLength !== null) {
            return value.length <= maxLength;
          }
          return true;
        });
    }
  });

  return yup.object().shape(schemaFields);
};
